<template>
    <div class="content_box nopadding">
        <div class="top fixed_top el_form">
            <div class="title">
                <span>设备清扫分析</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <el-select v-model="region" placeholder="请选择" @change="selectChanged" size="small">
                    <el-option label="全部区域" value=""></el-option>
                    <el-option label="美洲数据中心" value="us"></el-option>
                    <el-option label="中国数据中心" value="cn"></el-option>
                    <el-option label="欧洲数据中心" value="eu"></el-option>
                    <el-option label="亚太数据中心" value="ap"></el-option>
                </el-select>&nbsp;&nbsp;
                <el-select v-model="searchData.product_key" placeholder="全部产品" clearable @change="getDeviceClean"
                    size="small">
                    <el-option v-for="item in productList" :key="item.productKey" :label="item.name"
                        :value="item.productKey"></el-option>
                </el-select>&nbsp;&nbsp;
                <el-date-picker v-model="searchData.time_info" type="date" style="width: 180px;" size="small"
                    :picker-options="pickerOptions()" @change="getDeviceClean" value-format="yyyy-MM-dd"
                    :clearable="false">
                </el-date-picker>
            </div>
        </div>
        <div class="area">
            <div class="content">
                <div class="chart_box trend" ref="trend">
                    <div class="area_chart_box chart_item">
                        <div class="title subtitle">
                            <span>设备日清扫面积分布占比</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                                <div slot="content">
                                    <span>统计当天设备清扫数据，计算日清扫面积分布区间的设备数占比</span>
                                </div>
                                <img class="icon-tip" v-if="$store.state.type == 'pc'" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                            </el-tooltip>
                        </div>
                        <div class="area_chart chart" ref="area_chart"></div>
                    </div>
                    <div class="time_chart_box chart_item">
                        <div class="title subtitle">
                            <span>设备清扫时段分布占比</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="bottom-start">
                                <div slot="content">
                                    <span>统计当天设备清扫数据，计算不同清扫时段分布区间的设备数占比</span>
                                </div>
                                <img class="icon-tip" v-if="$store.state.type == 'pc'" src="../../../assets/images/ico/ic_tip.png" alt=""> 
                            </el-tooltip>
                        </div>
                        <div class="time_chart chart" ref="time_chart"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import resize from "../../../minxins/resize"
export default ({
    name: 'app-operation',
    mixins: [resize],
    data() {
        return {
            region: '',
            productList: [],
            searchData: {
                product_key: '',
                time_info: '',
            },
            resizeTimer: null,
            contentWidth: null,
            cleanData: [],
        }
    },
    watch: {
        contentWidth: function (nW) {
            var areaChart = this.echarts.init(this.$refs.area_chart);
            areaChart.resize();
            var timeChart = this.echarts.init(this.$refs.time_chart);
            timeChart.resize();
        },
    },
    created() {
        this.init()
        this.getIotProductList();
        this.getDeviceClean();
    },
    activated() {
        window.addEventListener('resize', this.onresize());
    },
    deactivated() {
        window.removeEventListener('resize', this.onresize());
    },
    methods: {
        init() {
            this.region = this.$route.query.region || this.region;
            const start = new Date()
            this.searchData.time_info = this.formDate(start.getTime() - 60 * 60 * 24 * 1000, 'YYYY-MM-DD');
        },
        onresize() {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.contentWidth = this.$refs.trend.offsetWidth;
            }, 200);
        },
        selectChanged() {
            this.$router.replace('?region=' + this.region);
            this.getDeviceClean();
        },
        getIotProductList() {
            this.api.getIotProductList().then(data => {
                this.productList = data.data.result;
                this.productList.unshift({ 'productKey': '', 'name': '全部产品' })
            })
        },
        getDeviceClean() {
            this.api.getDeviceClean(this.searchData).then(data => {
                this.cleanData = data.data.result[0];
                this.initBarLine();
            })
        },
        pickerOptions() {
            return {
                disabledDate(time) {
                    return time.getTime() > new Date().getTime() - 8.64e7 || time.getTime() < new Date('2022/12/29').getTime();
                }
            }
        },
        initBarLine() {
            let areaX = [];
            let areaY = [];
            let timeX = [];
            let timeY = [];
            areaX.push(this.cleanData.area_lt_twenty_rate, this.cleanData.area_lt_fifty_rate, this.cleanData.area_lt_hundred_rate, this.cleanData.area_gt_hundred_rate)
            areaY.push(this.cleanData.area_lt_twenty, this.cleanData.area_lt_fifty, this.cleanData.area_lt_hundred, this.cleanData.area_gt_hundred)
            timeX.push(this.cleanData.time_lt_six_rate, this.cleanData.time_lt_twelve_rate, this.cleanData.time_lt_eighteen_rate, this.cleanData.time_gt_eighteen_rate)
            timeY.push(this.cleanData.time_lt_six, this.cleanData.time_lt_twelve, this.cleanData.time_lt_eighteen, this.cleanData.time_gt_eighteen)
            var areaChart = this.echarts.init(this.$refs.area_chart);
            areaChart.clear();
            areaChart.setOption(this.setAreaOption('设备日清扫面积分布占比',areaX, areaY, ['0-20m³', '21-50m³', '51-100m³', '＞100m³']));
            var timeChart = this.echarts.init(this.$refs.time_chart);
            timeChart.clear();
            timeChart.setOption(this.setAreaOption('设备清扫时段分布占比',timeX, timeY, ['0:00-6:00', '06:00-12:00', '12:00-18:00', '18:00-24:00']));
        },
        setAreaOption(title,xData, yData, yAxis) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (p) => {
                        let str = `设备数：${yData[p[0].dataIndex]}<br />占比：${p[0].value + '%'}`;
                        return str;
                    }
                },
                legend: {},
                grid: {
                    left: 20,
                    right: '50%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    data: xData,
                    splitNumber: 5,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#E8E9F1'
                        }
                    },
                    splitLine: {
						show: false
					},
                    axisLabel: {
                        min: 0,
                        max: 100,
                        interval: 5,
                        show: true,
                        formatter: '{value}%',
                        color: '#868998',
                        fontSize: 12
                    },
                },
                yAxis: {
                    type: 'category',
                    data: yAxis,
                    axisLabel: {
                        color: '#868998',
                        fontSize: 12
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#E8E9F1'
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                series: [
                    {
                        type: 'bar',
                        data: xData,
                        itemStyle: {
                            color: '#507FF7',
                        },
                        label: {
                            show: true,
                            color: '#666',
                            align: 'left',
                            offset: [10, 0],
                            fontSize: 12,
                            position: 'insideRight',
                            formatter: (p) => {
                                return p.value ? p.value + '%' : '';
                            }
                        },
                        barWidth: 20,
                    }
                ]
            };
            return option;
        }
    }
})
</script>
<style lang="less" scoped>
@import '../../../less/statistics.less';

.area {
    height: calc(100% - 55px);

}

.title {
    /deep/ .el-select {
        width: 180px !important;
    }

    /deep/ .el-input__inner {
        min-width: 168px;
    }
}
.content{
    .chart_box {
        height: 100%;
        box-sizing: border-box;
        .flexLayout(space-between, flex-start);
        flex-wrap: wrap;
        margin-bottom: 0;
        .chart_item{
            width: 50%;
            height: 350px;
            .title{
                font-weight: 500;
                font-size: 16px;
            }
            .chart{
                height: 100%;
            }
        }
    }
}

@media (max-width: 768px) {
    .content{
        padding: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/statistics/device/device-clean.vue